import {Link, useLocation} from "react-router-dom";
import React from 'react';
import {classNames} from "../../utils/misc";
import {useAuth} from "../../contexts/AuthContext";

export function SecondaryNavigation({mobile = false}) {
    const {currentMainNavItem} = useAuth();
    const location = useLocation();

    // If no main nav item is selected or it has no children, don't render anything
    if (!currentMainNavItem || !currentMainNavItem.children || currentMainNavItem.children.length === 0) {
        return null;
    }

    const secondaryItems = currentMainNavItem.children;

    return (
        <div className="border-b border-gray-200 bg-white">
            <div className="mx-auto px-4 sm:px-6 lg:px-8">
                {/* Mobile dropdown */}
                <div className="sm:hidden">
                    <label htmlFor="tabs" className="sr-only">
                        Select a tab
                    </label>
                    <select
                        id="tabs"
                        name="tabs"
                        className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                        value={location.pathname}
                        onChange={(e) => window.location.href = e.target.value}
                    >
                        {secondaryItems.map((item) => (
                            <option key={item.path} value={item.path}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Desktop tabs */}
                <div className="hidden sm:block">
                    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                        {secondaryItems.map((item) => {
                            // Check if current path starts with the item path (handles sub-routes)
                            const isActive = location.pathname.startsWith(item.path);
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={classNames(
                                        isActive
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                        'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
                                    )}
                                    aria-current={isActive ? 'page' : undefined}
                                >
                                    {item.name}
                                </Link>
                            );
                        })}
                    </nav>
                </div>
            </div>
        </div>
    );
}

